module.exports = __webpack_public_path__ + "img/icon_qw.21672ede.svg";